// 批量赠送

const give = {
  namespaced: true,
  state: {
    params: {},
  },
  mutations: {
    SET_GIVE_PARAMS(state, payload) {
      state.params = payload.params || {};
    },
  },
};

export default give;
